import { Injectable } from '@angular/core';
import {
  NbGlobalPhysicalPosition,
  NbToastRef,
  NbToastrService,
} from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class SaveToastService {

  private currentRef: NbToastRef | null = null;

  private readonly position = NbGlobalPhysicalPosition.BOTTOM_RIGHT;

  constructor(
    private toastrService: NbToastrService,
    private translate: TranslateService,
  ) { }

  showSaving(message = ''): void {
    this.close();
    this.currentRef = this.toastrService.show(
      message || this.translate.instant('asset_form_drawer.save_status.saving'),
      undefined,
      {
        status: 'basic',
        position: this.position,
        duration: 5000,
        destroyByClick: false,
        hasIcon: true,
        icon: 'more-horizontal-outline',
        toastClass: 'save-toast-saving',
      },
    );
  }

  showSaved(message = ''): void {
    this.close();
    this.currentRef = this.toastrService.show(
      message || this.translate.instant('asset_form_drawer.save_status.saved'),
      undefined,
      {
        status: 'basic',
        position: this.position,
        duration: 3000,
        destroyByClick: true,
        hasIcon: true,
        icon: 'checkmark-outline',
        toastClass: 'save-toast-saved',
      },
    );
  }

  showError(message = ''): void {
    this.close();
    this.currentRef = this.toastrService.show(
      message || this.translate.instant('asset_form_drawer.save_status.error'),
      undefined,
      {
        status: 'danger',
        position: this.position,
        duration: 5000,
        destroyByClick: true,
        hasIcon: true,
        icon: 'alert-triangle',
        toastClass: 'save-toast-error',
      },
    );
  }

  close(): void {
    if (this.currentRef) {
      this.currentRef.close();
      this.currentRef = null;
    }
  }
}
